<template>
  <div class="sun-hero-guide-tile">
    <div class="sun-hero-guide-image">
      <a :href="`${this.href}`" target="_blank"> <img :class="{ imgborder: hasBorder }" v-bind:src="imageSource"/> </a>
    </div>
    <a :href="`${this.href}`" v-html="link" :target="{ target }" download>{{
        link
      }}</a>
  </div>
</template>
<script>
export default {
  name: 'SunheroThumbnailTile',
  props: ['image', 'href', 'link', 'hasBorder', 'url', 'title', 'target'],
  computed: {
    imageSource () {
      return require(`@/assets/images/global/${this.image}`)
    },
  },
  methods: {
    downloadWithAxios (href, title) {
      const _this = this
      _this.axios({
        method: 'get',
        href,
        responseType: 'arraybuffer',
      }).then((response) => {
        this.forceFileDownload(response, title)
      }).catch(() => console.log('error occured'))
    },
  },
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

.sun-hero-guide-tile {
  margin-right: 20px;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
    margin-right: 0px;
  }

  .sun-hero-guide-image {
    display: flex;
    flex-direction: column;

    width: 156px;
    height: 158px;
    @media (min-width: ~"@{mq-md-bp}" em) {
      margin-bottom: 2rem;
    }

    @media screen and (max-width: 768px) {
      margin-bottom: 5px;
    }

    img {
      width: 156px;
      height: 158px;
    }
  }

  .imgborder {
    border: 2px solid @color-orange;
  }

  a {
    color: @color-dk-orange;
    font-size: 16px;
    text-decoration: underline;
    line-height: 2rem;
    text-align: left;
    @media screen and (max-width: 400px) {
      text-align: center;
    }
  }
}
</style>
